export default {
  methods: {
    goToPlayer(playerData) {
      const player = JSON.parse(JSON.stringify(playerData));
      if (
        this.userData.userType === "Admin" ||
        this.userData.userType === "Coach"
      ) {
        this.$router.push({
          name: "profile",
          query: { playerData: JSON.stringify(player) },
        });
      }
    },
  },
};
